module.exports = __webpack_public_path__ + "static/media/有沒有討論地震災害避難方法 VS 是否知道住家附近的政府公告避難地點.b8750cba.png";